import type GameLocal from "~/libs/interfaces/GameLocal";
import type UserGameDetail from "~/libs/interfaces/UserGameDetail";
import type GameDrawLocal from "~/libs/interfaces/GameDrawLocal";
import type GameUserLocal from "~/libs/interfaces/GameUserLocal";
import type UserLocal from "~/libs/interfaces/UserLocal";

const userGameDetailFactory = {
  createUserGameDetail(
    user?: UserLocal | null,
    game?: GameLocal | null,
    activeDraw?: GameDrawLocal | null,
    gameUser?: GameUserLocal | null
  ): UserGameDetail {
    return {
      user,
      game,
      activeDraw,
      gameUser
    }
  }
}
export default userGameDetailFactory